// extracted by mini-css-extract-plugin
export default {"disclosure":"ProteinSourcingDisclosure-module__disclosure__aczVM","link":"ProteinSourcingDisclosure-module__link__Ct0cV"};